import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import * as actions from '../actions';
import { PubnubState } from '..';

export const getSystemChannelMetadataBuilder = (builder: ActionReducerMapBuilder<PubnubState>) => {
  return builder
    .addCase(actions.getSystemChannelMetadata.pending, (state) => {
      state.isBusy = true;
    })
    .addCase(actions.getSystemChannelMetadata.fulfilled, (state) => {
      state.isBusy = false;
    })
    .addCase(actions.getSystemChannelMetadata.rejected, (state) => {
      state.isBusy = true;
    });
};
